// extracted by mini-css-extract-plugin
export default {"bi":"Input_bi__cV1fk"};